//Order is important, it determines target layer priority on the map
export enum IdentificationEnum {
  DRONE = 'DRONE',
  REMOTE_CONTROL = 'REMOTE_CONTROL',
  AIRCRAFT = 'AIRCRAFT',
  VCA = 'VCA',
  UNKNOWN = 'UNKNOWN',
  BIRD = 'BIRD',
  SHIP = 'SHIP',
  PERSON = 'PERSON',
  GROUND_VEHICLE = 'GROUND_VEHICLE',
  HELICOPTER = 'HELICOPTER',
  BUILDING = 'BUILDING',
}

export enum StrobeIdentificationEnum {
  UNKNOWN = 'UNKNOWN',
  REMOTE_CONTROL = 'REMOTE_CONTROL',
  DRONE = 'DRONE',
}

export enum PolygonIdentificationEnum {
  UNKNOWN = 'UNKNOWN',
  REMOTE_CONTROL = 'REMOTE_CONTROL',
  DRONE = 'DRONE',
}

export enum IdentificationOriginEnum {
  COMPUTED = 'COMPUTED',
  MANUAL = 'MANUAL',
}

export enum ReliabilityEnum {
  UNSURE = 'UNSURE',
  SURE = 'SURE',
}

// TODO: HLF#66351 : restore identification only by record when no more replay before 5.8
export interface Identification {
  identifications: Partial<Record<IdentificationEnum, number>> | IdentificationEnum;
  autoIdentification: IdentificationEnum;
  manualIdentification: Partial<Record<string, IdentificationEnum>> | IdentificationEnum;
  reliability: ReliabilityEnum;
}
